// extracted by mini-css-extract-plugin
export default {"SubjectList":"BykR5EOLmnl0V0SBAQnQ","SubjectListItem":"Uh4nTKxwrnkLVPLOjPTA","Variant--compact":"y8Im8WPr4V5wvOB8jtLM","Variant--default":"vb0njwpyNgGsEMifwP0i"};